import { render, staticRenderFns } from "./communication-section.vue?vue&type=template&id=64135ff6"
import script from "./communication-section.vue?vue&type=script&lang=js"
export * from "./communication-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports